import { LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/auth/AuthProvider";
import { useCurrentUser } from "@/api/queries/me";
import { useDepartments } from "@/api/queries/departments";
import { isRespaiAdmin } from "@/lib/permissions";
import { useAppStore } from "@/store/app-store";
import { DepartmentSwitcher } from "@/components/department-switcher";

export function Topbar() {
  const { signOut, identity } = useAuth();
  const me = useCurrentUser();
  const isPlatformAdmin = isRespaiAdmin(identity?.role);
  const selectedDeptId = useAppStore((s) => s.selectedDepartmentId);
  const { data: departments } = useDepartments();
  const selectedDept = departments?.find((d) => d.id === selectedDeptId);
  const departmentLabel = isPlatformAdmin
    ? selectedDept?.name ??
      (selectedDeptId === "all" ? "All departments" : "RespAI Platform")
    : me.data?.department?.name ?? "—";
  return (
    <header className="flex h-14 items-center justify-between border-b border-border bg-background px-6 print:hidden">
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        {!isPlatformAdmin && me.data?.department?.logo_url ? (
          <img
            src={me.data.department.logo_url}
            alt=""
            className="h-7 w-7 rounded object-contain"
          />
        ) : null}
        <span>{departmentLabel}</span>
      </div>
      <div className="flex items-center gap-3">
        {isPlatformAdmin ? <DepartmentSwitcher /> : null}
        <div className="text-right text-xs leading-tight">
          <div className="font-medium text-foreground">
            {me.data?.display_name ||
              me.data?.email ||
              identity?.email ||
              "Signed in"}
          </div>
          <div className="text-muted-foreground">{identity?.role}</div>
        </div>
        <Button variant="ghost" size="sm" onClick={() => void signOut()}>
          <LogOut className="mr-1 h-4 w-4" />
          Sign out
        </Button>
      </div>
    </header>
  );
}
